/**
 * @generated SignedSource<<8d09ccf1045cb513d8064a024e6eee52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useGetLangTranslatesQuery$variables = {
  toLang: string;
};
export type useGetLangTranslatesQuery$data = {
  readonly langTranslates: ReadonlyArray<{
    readonly code: string | null;
    readonly name: string | null;
  } | null>;
};
export type useGetLangTranslatesQuery = {
  response: useGetLangTranslatesQuery$data;
  variables: useGetLangTranslatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toLang"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "toLang",
        "variableName": "toLang"
      }
    ],
    "concreteType": "LangTranslate",
    "kind": "LinkedField",
    "name": "langTranslates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGetLangTranslatesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetLangTranslatesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "823de10cfd921c4f2625d543f8482936",
    "id": null,
    "metadata": {},
    "name": "useGetLangTranslatesQuery",
    "operationKind": "query",
    "text": "query useGetLangTranslatesQuery(\n  $toLang: String!\n) {\n  langTranslates(toLang: $toLang) {\n    code\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9882425d582c04146d1edf46818e3c5";

export default node;
